import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      me: this.$store.state.user.me
    };
  },
  computed: {
    authService() {
      const AuthorizationService = require('@/services/AuthorizationService');
      return new AuthorizationService();
    }
  }
});
